export type GetIfConversionRulesResponse = {
  envCopyIfDfnCnvRule: EnvCopyIfDfnCnvRule[];
};

export type EnvCopyIfDfnCnvRule = {
  ifDfnCnvRuleId: string;

  envrnmntIdFrom: string;
  envrnmntIdTo: string;

  cpntId: string;

  bdryId: string;

  ifItmGrpNum: number;

  ifItmGrpLgclName: string;

  ifItmNum: number;
  ifItmLgclName: string;

  ifDfnCnvRuleTypeCd: string;

  ifDfnCnvRuleTypeName: string;

  rplcmntFromAttrStngVal: string;

  rplcmntToAttrStngVal: string;

  prefxStngVal: string;

  updateDateTime: string;
};
